module.exports = __webpack_public_path__ + "329f9a9807e04ee00c7bc0d082f19e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/logo/page2_glow.png
// module id = 661
// module chunks = 0